module.exports = __webpack_public_path__ + "img/14h-doc-acao-verificar.da3efbd0.png";